export default __webpack_public_path__ + "static/media/AGC_2025_R1_QP_Class_5.3f8dea9a.pdf";